<template>
  <div>
    <BannerInternoBlog></BannerInternoBlog>
    <div class="blog__topo ui-container">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="blog__topo__categorias">
              <ul class="row justify-content-center">
                <!-- se colocar a classe active ele fica com a LI selecionada -->
                <li v-for="(item, index) in tags" :key="index" :class="{'active': tag.slug == item.slug}">
                  <router-link :to="{ name: 'BlogTag', params: { slug: item.slug }}">
                    {{item.name}}
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="blog ui-container">
      <div class="container">
        <BlogCard :blogs="blogs.data"></BlogCard>
        <Paginacao :page="blogs.current_page" :lastPage="blogs.last_page" :rota="this.$route.name" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import BannerInternoBlog from './BannerInternoBlog.vue'
import BlogCard from './BlogCard.vue'
import Paginacao from './paginacao.vue'

export default {
  data () {
    return {
      tag: {}
    }
  },
  components: {
    BannerInternoBlog,
    BlogCard,
    Paginacao
  },
  computed: {
    ...mapGetters([
      'blogs',
      'tags'
    ])
  },
  created () {
    this._loadBlogs()
  },
  watch: {
    '$route' (to, from) {
      this._loadBlogs()
    }
  },
  methods: {
    _loadBlogs () {
      this.$store.dispatch('loadTags')
        .then(() => {
          if (!this.$route.params.slug) {
            this.tag = this.tags[0]
          } else {
            this.tags.forEach((tag) => {
              if (tag.slug === this.$route.params.slug) {
                this.tag = tag
              }
            })
          }
          let params = {
            tag: this.tag,
            page: this.$route.query.page
          }
          this.$store.dispatch('loadBlogs', params)
        })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../assets/scss/_variables.scss';
.blog {
  background: white;
}
.blog__topo {
  background: $bgIntern;
  &__categorias {
    li {
      margin: 0 15px;
      a {
        color: $silver;
        font-size: 16px;
        text-transform: uppercase;
        transition: all 0.3s;
        &:hover {
          color: $green;
          transition: all 0.3s;
        }
      }
      &.active {
        font-weight: bold;
        transition: all 0.3s;
        position: relative;
        &:before {
          background: $green;
          bottom: -84px;
          content: '';
          height: 9px;
          left: 0;
          position: absolute;
          transition: all 0.3s;
          width: 100%;
          @media (max-width: 1200px){
            bottom: -64px;
          }
        }
      }
    }
  }
}
@media (max-width: 991px){
  .blog__topo__categorias {
    li {
      &.active {
        &:before {
          bottom: -64px;
        }
      }
    }
  }
}
@media (max-width: 767px){
  .blog__topo__categorias {
    li {
      margin-bottom: 5px;
      text-align: center;
      width: 100%;
      &.active {
        &:before {
          display: none;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Blog.vue